import React from "react";
import { IoIosArrowDroprightCircle } from "react-icons/io";
import ExperienceTabs from "./ExperienceTabs";

const Experience = () => {
  return (
    <div id="experience" className="mb-10 md:mb-0">
      {/* Headline */}
      <div className="flex justify-evenly items-center">
        <h3 className="font-bitter tracking-wider text-3xl font-bold">
          <span className="mr-2 text-teal-300">03.</span>Experience
        </h3>
        <div className="w-[100px] md:w-[200px] lg:w-[50vh] h-[0.5px] bg-gray-200 ml-4" />
      </div>

      {/* Tabs */}
      <div data-aos="fade-up" className="min-h-full flex justify-center">
        <ExperienceTabs />
      </div>
    </div>
  );
};

export default Experience;
